import React, { useEffect, useState } from "react";
import axios from "axios";
import { PlayCircle } from "lucide-react";
import { Reveal, SectionHeading } from "../shared/Primitives";
import { DotGrid, Sparkle } from "../shared/Decor";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VirtualTour = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setUrl(r.data?.virtual_tour_url || "")).catch(() => {});
  }, []);

  return (
    <section id="recorrido" data-testid="virtual-tour-section" className="relative overflow-hidden bg-espresso py-16 sm:py-20 lg:py-28">
      <DotGrid className="absolute top-12 right-10 w-28 text-linen/15 hidden sm:block" />
      <Sparkle className="absolute bottom-16 left-10 w-9 text-camel/40 hidden lg:block" />
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 relative z-10">
        <SectionHeading
          light
          overline="Vívelo antes de llegar"
          title="Recorrido virtual"
          subtitle="Pasea por los espacios comunes y siente la vibra de la comunidad desde donde estés."
        />

        <Reveal className="mt-14">
          <div className="relative w-full aspect-video overflow-hidden border border-white/10 bg-black shadow-2xl">
            {url ? (
              <iframe
                data-testid="virtual-tour-iframe"
                title="Recorrido virtual COLLECTIVE CO LIVING"
                src={url}
                className="w-full h-full"
                style={{ border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <div className="w-full h-full flex flex-col items-center justify-center text-center px-8" data-testid="virtual-tour-empty">
                <PlayCircle size={48} strokeWidth={1.2} className="text-white/50" />
                <p className="mt-4 text-lg font-light text-white/60">El recorrido virtual estará disponible muy pronto.</p>
              </div>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
